import moment from '@/plugins/moment';
import { toCamelCaseProperties } from '@/utils/fn';

export default class Consent {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.consentCategory = args.consentCategory || '';
		this.consentDescription = args.consentDescription || '';
		this.consentDescriptionFull = args.consentDescriptionFull || '';
		this.consentType = args.consentType || 0;
		this.history = (args.history || []).map(history => new ConsentHistory(history));
		this.responsePlatform = args.responsePlatform || 0;
		this.responseTime = moment(args.responseTime || '');
		this.responseValue = !!args.responseValue;
	}
}

export class ConsentHistory {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.editedByCustomer = !!args.editedByCustomer;
		this.responsePlatform = args.responsePlatform || 0;
		this.responseTime = moment(args.responseTime || '');
		this.responseValue = !!args.responseValue;
	}
}
